import React from "react"

import { useStyles } from "@/components/ProfileSection/Heading/Heading.styles"

export const Heading = ({ children }) => {
    const { classes } = useStyles()

    return <h2 className={classes.heading}>{children}</h2>
}
